export default __webpack_public_path__ + "static/media/ZacharyKatzman.80098b6b.jpg";